import { MapLayerGroupControl } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerGroupControl';
import { useAppSelector, useAppDispatch } from '@/app/hooks';
import { update as updateMapLayerConfig } from '@/features/mapLayerSlice';
import { LayerType } from '@/views/map/layers/types';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { FuelHazardLegend } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerOption/FuelHazardLegend';
import TagManager from 'react-gtm-module';
import { GoogleEvents } from '@/features/googleEvents';
import { useClientTerminology } from '@/hooks/useClientTerminology';

export const FuelHazardControl = () => {
  const dispatch = useAppDispatch();
  const layerConfig = useAppSelector((s) => s.mapLayer);
  const { formatMessage } = useClientTerminology();

  const isActive = layerConfig[LayerType.fuel_hazard].visible;

  const toggleFuelHazardLayer = (v: boolean) => {
    TagManager.dataLayer({
      dataLayer: {
        event: v
          ? GoogleEvents.fuelHazardLayerOn
          : GoogleEvents.fuelHazardLayerOff,
      },
    });
    return dispatch(
      updateMapLayerConfig({
        [LayerType.fuel_hazard]: { visible: v },
      })
    );
  };

  const isSmallScreen = useSmallScreen();

  return (
    <>
      <MapLayerGroupControl
        title={formatMessage({ id: 'map.layerManager.fuelHazardTitle' })}
        description={formatMessage({
          id: 'map.layerManager.fuelHazardDescription',
        })}
        onVisibilityChange={toggleFuelHazardLayer}
        isGroupVisible={isActive}
        data-testid="fuel-hazard-control"
      />
      {isSmallScreen && isActive && <FuelHazardLegend />}
    </>
  );
};
